import { call, put, takeLatest } from "redux-saga/effects";

import {
  GET_CUSTOMER_PROFILE_DATA,
  GOT_CUSTOMER_PROFILE_DATA,
  SAVE_NEW_CUSTOMER_DATA,
  SAVED_NEW_CUSTOMER_DATA,
  SAVE_EDITED_CUSTOMER_DATA,
  SAVED_EDITED_CUSTOMER_DATA,
  LIMITED_PERMISSIONS
} from "../customerProfile";
import { getLocalStorageItem, getOrgId } from "../../utils/helpers";
import { handleApiErrors } from "./helpers";
import { UPDATED_GLOBAL_SUCCESS_MESSAGE } from "../globalSuccess";

/***** SAGA START ******/
export let getCustomerProfileDataWithCustomerId = ({ customerId }) => {
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  if (!customerId) {
    logger.error("No customer ID somehow");
    return;
  }

  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}`,
    {
      headers: { Authorization: getLocalStorageItem("token_authorization") }
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* loadCustomerProfileData(customerId) {
  try {
    const data = yield call(getCustomerProfileDataWithCustomerId, customerId);

    window.loadingCustomerProfile = false;
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: GOT_CUSTOMER_PROFILE_DATA, data });
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let saveNewCustomerProfileDataWithPayload = ({ payload }) => {
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return handleApiErrors({ generalError: true });
  }
  const request = JSON.stringify(payload);
  return fetch(
    `${window.APP.apiPath}api/organization/${getOrgId()}/customers`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json"
      },
      method: "POST",
      body: request
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (payload.cb) {
            payload.cb();
          }
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* saveNewCustomerProfileData(payload) {
  try {
    const data = yield call(saveNewCustomerProfileDataWithPayload, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SAVED_NEW_CUSTOMER_DATA, data });
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Success.CreatedCustomer,
          icon: "saved_icon"
        }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

/***** SAGA START ******/
let saveEditedCustomerProfileDataWithPayload = ({ payload, customerId }) => {
  if (!getOrgId()) {
    logger.error("Org id should be defined before you execute this function");
    return;
  }
  if (!customerId) {
    logger.error("No customer ID somehow");
    return;
  }
  const request = JSON.stringify(payload);
  return fetch(
    `${
      window.APP.apiPath
    }api/organization/${getOrgId()}/customers/${customerId}`,
    {
      headers: {
        Authorization: getLocalStorageItem("token_authorization"),
        "Content-Type": "application/json"
      },
      method: "PUT",
      body: request
    }
  )
    .then(response => {
      return response.json().then(result => {
        if (result.code && result.code != 200) {
          return handleApiErrors(result);
        } else {
          if (payload.cb) {
            payload.cb();
          }
          return result;
        }
      });
    })
    .catch(error => {
      logger.error(error);
      throw error;
    });
};

function* saveEditedCustomerProfileData(payload) {
  try {
    const data = yield call(saveEditedCustomerProfileDataWithPayload, payload);
    if (!data || data.error) {
      yield put(data.error); // Yields effect to the reducer specifying the action type and user details
    } else {
      yield put({ type: SAVED_EDITED_CUSTOMER_DATA, data });
      yield put({
        type: UPDATED_GLOBAL_SUCCESS_MESSAGE,
        data: {
          message: window.APP.LANGUAGE.Success.UpdatedCustomerData,
          icon: "saved_icon"
        }
      }); // Yields effect to the reducer specifying the action type and user details
    }
  } catch (error) {
    throw error;
  }
}
/***** SAGA END ******/

function* watchRequests() {
  yield* [
    takeLatest(GET_CUSTOMER_PROFILE_DATA, loadCustomerProfileData),
    takeLatest(SAVE_NEW_CUSTOMER_DATA, saveNewCustomerProfileData),
    takeLatest(SAVE_EDITED_CUSTOMER_DATA, saveEditedCustomerProfileData)
  ];
}

export default [watchRequests];
